import React from "react";
import { Row, Col } from "antd";
import styles from "../DashBoard/DashBoard.module.scss";
import { ITripDetails } from "../ServiceUsers/Interfaces/ITripDetails";
import moment from "moment";
import { infoIcon } from "../../assets/images";
import { usePlanDetailsCtx } from "../../context/PlanDetailsContext";

type Props = {
  trip: ITripDetails;
};

const TripTimings: React.FC<Props> = ({ trip }) => {
  const { tripDetailsInfo } = usePlanDetailsCtx();
  const getTripArrivedByLeaveAt = () => {
    let returnString;
    if (trip?.appointmentTime === null) {
      returnString = `Leave At - ${moment(trip?.requestPickTime).format(
        "hh:mm A"
      )}`;
    } else {
      returnString = `Arrive By - ${moment(trip?.appointmentTime).format(
        "hh:mm A"
      )}`;
    }
    return returnString;
  };

  const getTripArrivedByLeaveAtMessage = () => {
    let returnString;
    if (trip?.appointmentTime === null) {
      returnString = `Driver will arrive at the pickup address by ${moment(
        trip?.requestPickTime
      ).format("hh:mm A")}.`;
    } else {
      returnString = `${
        trip?.serviceUser.split(" ")[0]
      } will arrive at the dropoff
      address by ${moment(trip?.appointmentTime).format("hh:mm A")}.`;
    }
    return returnString;
  };

  return (
    <>
      <Row className={styles.expandFirstHeadingMargin}>
        <Col xs={1} sm={3} md={6} lg={0} />
        <Col xs={22} sm={18} md={12} lg={24} className={styles.expandHeading}>
          Pickup Time
        </Col>
        <Col xs={1} sm={3} md={6} lg={0} />

        <Col xs={1} sm={3} md={6} lg={0} />
        <Col xs={22} sm={18} md={12} lg={24} className={styles.expandDetails}>
          {trip.isWillCall
            ? `I'll call when ${
                trip?.serviceUser.split(" ")[0]
              } is ready to be picked up.`
            : getTripArrivedByLeaveAt()}
        </Col>
        <Col xs={1} sm={3} md={6} lg={0} />

        <Col xs={1} sm={3} md={6} lg={0} />
        <Col xs={22} sm={18} md={12} lg={24}>
          <Row className={styles.expandInfo} gutter={[3, 0]}>
            <Col xs={1} lg={1}>
              <img src={infoIcon} alt="info" />
            </Col>
            <Col xs={22} lg={23}>
              {trip.isWillCall
                ? `Call us at ${tripDetailsInfo.wandaCustomerCareNumber} for pickup.`
                : getTripArrivedByLeaveAtMessage()}
            </Col>
            <Col xs={1} lg={0} />
          </Row>
        </Col>
        <Col xs={1} sm={3} md={6} lg={0} />
      </Row>
      <Row className={styles.expandHeadingMargin}>
        {trip?.pickupNotes && (
          <>
            <Col xs={1} sm={3} md={6} lg={0} />
            <Col span={24} className={styles.expandHeading}>
              Pickup Instructions
            </Col>
            <Col xs={1} sm={3} md={6} lg={0} />

            <Col xs={1} sm={3} md={6} lg={0} />
            <Col span={24} className={styles.expandDetails}>
              {trip?.pickupNotes}
            </Col>
            <Col xs={1} sm={3} md={6} lg={0} />
          </>
        )}
      </Row>
      <Row className={styles.expandHeadingMargin}>
        {trip?.dropNotes && (
          <>
            <Col xs={1} sm={3} md={6} lg={0} />
            <Col span={24} className={styles.expandHeading}>
              Dropoff Instructions
            </Col>
            <Col xs={1} sm={3} md={6} lg={0} />

            <Col xs={1} sm={3} md={6} lg={0} />
            <Col span={24} className={styles.expandDetails}>
              {trip?.dropNotes}
            </Col>
            <Col xs={1} sm={3} md={6} lg={0} />
          </>
        )}
      </Row>
    </>
  );
};
export default TripTimings;
